export const ONBOARDING_CALL_URL = 'https://cal.com/braintastic/shakespeareai-onboarding';
export const INVITATION_DELAY_MS = 3 * 60 * 1000;
const MAX_AGE_MS = 7 * 24 * 60 * 60 * 1000;
export const invitationKey = (userId: number) => `onboarding-call-v1:${userId}`;
export interface InvitationRecord { startedAt: number; foregroundMs: number; offered: boolean }

// Only confirmed new-account paths opt in. Existing users still have the footer link.
export function markOnboardingSignup(userId: number): void {
  if (!Number.isInteger(userId) || userId <= 0) return;
  try {
    if (localStorage.getItem(invitationKey(userId))) return;
    localStorage.setItem(invitationKey(userId), JSON.stringify({ startedAt: Date.now(), foregroundMs: 0, offered: false }));
  } catch { /* No persistent storage: use the permanent menu link only. */ }
}
export function readInvitation(userId: number): InvitationRecord | null {
  try {
    const value = JSON.parse(localStorage.getItem(invitationKey(userId)) || 'null');
    if (!value || !Number.isFinite(value.startedAt) || !Number.isFinite(value.foregroundMs) ||
        value.foregroundMs < 0 || typeof value.offered !== 'boolean' ||
        Date.now() < value.startedAt || Date.now() - value.startedAt > MAX_AGE_MS) return null;
    return value;
  } catch { return null; }
}
export function saveInvitation(userId: number, value: InvitationRecord): boolean {
  try { localStorage.setItem(invitationKey(userId), JSON.stringify(value)); return true; }
  catch { return false; }
}
